export default "__VITE_ASSET__Bois9mrV__"